import { updateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutMutation } from '@/generated/@tanstack/react-query.gen'
import { getPaymentMethodConfig } from '@/pages/enterprise/_data/payment-method-config'
import { PaymentMethodType } from '@/pages/enterprise/_data/payment-method-schema'
import { useUser } from '@/pages/enterprise/user-provider'
import { useMutation } from '@tanstack/react-query'
import { toast as customToast } from '@/components/custom-toast'
import PaymentDialogRemovePaymentMethod from './payment-method-dialog-remove'
import { useState } from 'react'

interface Props {
  paymentMethod: PaymentMethodType
}

export default function PaymentMethodItem({ paymentMethod }: Props) {
  const { organizationId, onUpdateSeats } = useUser()
  const [openDialogRemovePaymentMethod, setOpenDialogRemovePaymentMethod] =
    useState(false)

  const paymentMethodConfig = getPaymentMethodConfig(paymentMethod.type)

  const {
    mutate: updateDefaultPaymentMethod,
    isPending: isPendingUpdateDefaultPaymentMethod,
  } = useMutation({
    ...updateDefaultPaymentMethodOrganizationOrganizationIdUpdateDefaultPaymentMethodNewDefaultPaymentIdPutMutation(
      {}
    ),
    onSuccess: () => {
      customToast.success({
        message: 'Default payment method updated.',
      })
      onUpdateSeats()
    },
  })

  const onSetDefault = () => {
    const path = {
      new_default_payment_id: paymentMethod.payment_method_id,
      organization_id: organizationId,
    }

    updateDefaultPaymentMethod({
      path: path,
    })
  }

  const onDelete = () => setOpenDialogRemovePaymentMethod(true)

  return (
    <>
    
      <PaymentDialogRemovePaymentMethod
        open={openDialogRemovePaymentMethod}
        onOpenChange={() => setOpenDialogRemovePaymentMethod(false)}
        paymentMethodId={paymentMethod.payment_method_id}
      />

      <div className="border rounded-lg shadow-sm p-4 flex flex-col items-start transition-all hover:shadow-md">
        <div className="flex items-start justify-between w-full">
          <div className="flex items-start gap-4">
            <div className="transition-transform hover:scale-105">
              {paymentMethodConfig?.icon}
            </div>
            <div className="flex flex-col gap-2 items-start">
              <p className="text-base font-semibold">
                {paymentMethodConfig?.label} ****
                {paymentMethod.last_four_digits}
              </p>
              <p className="text-base">
                {paymentMethodConfig?.format(paymentMethod)}
              </p>
              <div className="flex flex-wrap gap-4">
                {!paymentMethod.is_default_payment && (
                  <div
                    className="!p-0 !py-0 bg-transparent text-primary font-normal cursor-pointer transition-colors hover:text-primary/80"
                    onClick={onSetDefault}
                  >
                    {isPendingUpdateDefaultPaymentMethod ? (
                      <div className="flex items-center gap-2">
                        <div className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
                        <span>Setting as Default...</span>
                      </div>
                    ) : (
                      'Set as Default'
                    )}
                  </div>
                )}
                <div
                  className="!p-0 !py-0 bg-transparent text-[#EF3826] font-normal cursor-pointer transition-colors hover:text-[#EF3826]/80"
                  onClick={onDelete}
                >
                  Delete
                </div>
              </div>
            </div>
          </div>
          {Boolean(paymentMethod.is_default_payment) && (
            <span className="bg-[#404040] text-white uppercase text-xs px-2 py-1 rounded">
              DEFAULT
            </span>
          )}
        </div>
      </div>
    </>
  )
}
